import React, {useState } from 'react';
import { NavLink } from 'react-router-dom'
import { Auth } from 'aws-amplify';
import { Segment, Menu, Icon } from 'semantic-ui-react'




function Navbar(user) {
    const [activeItem, setActiveItem] = useState("home")

    const handleItemClick = (e, {name}) => setActiveItem(name)
 
    return (
        <Segment>
        <Menu>
           <Menu.Item name='home'
                as={NavLink} to="/"
                active={activeItem === 'home'}
                onClick={handleItemClick}> <Icon name="home" size="large"/></Menu.Item>
           <Menu.Item name='customers'
                as={NavLink} to="/customers"
                active={activeItem === 'customers'}
                onClick={handleItemClick}>Customers</Menu.Item>
           
           <Menu.Menu position='right'>
              <Menu.Item name='about'
                as={NavLink} to="/about"
                active={activeItem === 'about'}
                onClick={handleItemClick}><Icon name="info circle" color = "blue" size="large"/></Menu.Item>
              <Menu.Item name='user'
                as={NavLink} to="/userinfo"
                active={activeItem === 'user'}
                onClick={handleItemClick}><Icon name="user outline" size="large"/>{user.user}</Menu.Item>
              <Menu.Item name='logout' onClick={ () => {Auth.signOut()
                                                          .then(data => console.log(data))
                                                          .catch(err => console.log(err));
                                                          }} active={false}>
                                        <Icon name="logout" size="large"/>Logout</Menu.Item>
           </Menu.Menu>

         </Menu>
         
      </Segment>

    )
}


export default Navbar